import React from "react";
import "./Healthcare.css";
import Navbar from "../components/Navbar";

const EducationAndSkilling = () => {
  return (
    <>
      <Navbar />
      <div className="industry1-container">
        <div className="industry1-content">
          <p className="para">Industries / Education & Skilling</p>
          <h2>Education & Skilling</h2>
          <p className="subtitle1">
            Reimagining Learning with XR for Deeper Understanding, Retention & Accessibility
          </p>
          <p>
            At Spatial Computing Technologies (SpatialCT), we empower educators, training institutions,
            and skill development centers with immersive XR solutions that bring learning to life. From virtual
            science labs to industry-relevant skill simulators, we create hands-on, engaging, and scalable
            experiences that align with modern pedagogical goals and National Education Policy (NEP)
            directives.
          </p>

          <div className="industry1-grid">
            <div className="industry1-row">
              <div className="industry1-box">
                <h4>Immersive Conceptual Learning for K–12 & Higher Ed</h4>
                <p>Bring abstract textbook concepts to life in interactive, explorable 3D environments.</p>
                <ul>
                  <li>Visualize physics, biology, chemistry, math, and geography in VR/AR</li>
                  <li>Use real-world analogies, gamified quizzes, and scenario-based tasks</li>
                  <li>Available in multiple Indian languages for regional scalability</li>
                </ul>
                <p><strong>Ideal for:</strong> Schools, colleges, ed-tech startups</p>
              </div>

              <div className="industry1-box">
                <h4>Vocational XR Skill Simulators</h4>
                <p>Develop hands-on, safe, and repeatable virtual training environments for industrial skills.</p>
                <ul>
                  <li>VR welding, CNC operation, crane driving, forklift handling, etc.</li>
                  <li>Skill tracking, performance assessment, and certification-ready modules</li>
                  <li>Portable versions for remote or rural training centers</li>
                </ul>
                <p><strong>Ideal for:</strong> ITIs, skilling agencies, CSR programs</p>
              </div>
            </div>

            <div className="industry1-row">
              <div className="industry1-box">
                <h4>Virtual Labs for Science & Engineering</h4>
                <p>Create simulation-based lab environments for physics, electronics, circuits, fluid dynamics, etc.</p>
                <ul>
                  <li>Enable experimentation without costly physical equipment</li>
                  <li>Scalable across institutions with low infrastructure</li>
                  <li>Includes lab manuals, analytics, and student dashboards</li>
                </ul>
                <p><strong>Ideal for:</strong> Engineering colleges, diploma/polytechnic institutes</p>
              </div>

              <div className="industry1-box">
                <h4>XR Learning Kits for Tier 2/3 Institutions</h4>
                <p>Affordable, mobile-first XR kits designed to democratize access to immersive learning tools.</p>
                <ul>
                  <li>Run on Android phones with simple headsets and Bluetooth remotes</li>
                  <li>Use preloaded multilingual content aligned with curriculum</li>
                  <li>Track usage, engagement, and performance offline</li>
                </ul>
                <p><strong>Ideal for:</strong> Rural schools, community colleges, NEP innovation hubs</p>
              </div>
            </div>

            <div className="industry1-row">
              <div className="industry1-box">
                <h4>Teacher Upskilling & Faculty Enablement in XR</h4>
                <p>Train educators to design, use, and integrate XR into their pedagogy and classroom delivery.</p>
                <ul>
                  <li>Workshops and certification programs for educators</li>
                  <li>Hands-on sessions with Unity3D, scenario design, learning outcome mapping</li>
                  <li>Focus on cognitive load theory, spatial learning principles, and HCI</li>
                </ul>
                <p><strong>Ideal for:</strong> Teacher training institutes, B.Ed. programs, school management</p>
              </div>
            </div>
          </div>

          {/* Use Cases Table */}
          <div className="usecases-section">
            <h3>Use Cases At a Glance</h3>
            <div className="table-wrapper">
              <div className="usecases-table">
                <div className="usecases-row usecases-header">
                  <div>Use Case</div>
                  <div>Target Users</div>
                  <div>Solution Type</div>
                  <div>Benefits</div>
                </div>
                <div className="usecases-row">
                  <div>STEM Learning</div>
                  <div>K-12, Colleges</div>
                  <div>VR Modules</div>
                  <div>High engagement, concept clarity</div>
                </div>
                <div className="usecases-row">
                  <div>Industrial Skills</div>
                  <div>Skilling Centers</div>
                  <div>VR Simulators</div>
                  <div>Safe, repeatable practice</div>
                </div>
                <div className="usecases-row">
                  <div>Engineering Labs</div>
                  <div>Polytechnic, BTech</div>
                  <div>Virtual Labs</div>
                  <div>Cost-saving, scalable labs</div>
                </div>
                <div className="usecases-row">
                  <div>Rural Access</div>
                  <div>Govt & NGO schools</div>
                  <div>Mobile XR Kits</div>
                  <div>Inclusive, multilingual learning</div>
                </div>
                <div className="usecases-row">
                  <div>Faculty Training</div>
                  <div>Teacher Institutes</div>
                  <div>XR Upskilling</div>
                  <div>Curriculum integration, confidence building</div>
                </div>
              </div>
            </div>

            <div className="usecases-cta">
              <h4>Partner With Us to Empower the Next Generation</h4>
              <p>
                Let’s transform how India learns and builds skills. Whether you're a school, college, university, or
                skilling agency, we can co-create XR-powered education platforms tailored to your context.
              </p>
              <p><strong>Contact us</strong> today to schedule a demo, explore co-development, or discuss CSR/NEP collaborations.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EducationAndSkilling;
